module.exports = __webpack_public_path__ + "img/503.98b3019a.png";